export default "__VITE_ASSET__b70b2c33__"